import React, { useEffect, useState } from "react";
import Bet_Diskon from "./FiveDComponent/Bet_Diskon";
import Bet_Full from "./FiveDComponent/Bet_Full";
import Prize from './FiveDComponent/Prize'
import FiveDSixDBetDiscountVersiWap from './FiveDComponent/FiveDSixDBetDiscountVersiWap'
import { useDispatch, useSelector } from "react-redux";
import FiveDSixDBetFullVersiWap from "./FiveDComponent/FiveDSixDBetFullVersiWap";
import FiveDSixDPrizeVersiWap from "./FiveDComponent/FiveDSixDPrizeVersiWap";
import { set4dGameSubChildtype, setCommonConfig } from "../../../../redux/actions";
import MarketClose from "../MarketClose";
import ZeroBalancePopup from "../ZeroBalancePopup";
import GameClosedPopup from "../GameClosedPopup";
import { withTranslation } from "react-i18next";

const FiveDSixDMain = (props) => {
  const dispatch = useDispatch();
  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const user_profile = useSelector(state => state.UserProfile);
  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [multipleValue, setMultipleValue] = useState('');
  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabIndex) => {      
    setActiveTab(tabIndex);
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: tabIndex == "1" ? "DISCOUNT" : tabIndex == "2" ? "FULLBET" : tabIndex == "3" ? "PRIZE" : "" }));
  };

  useEffect(() => {
    setActiveTab(1)
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
  }, [gameId])
  useEffect(() => {
    dispatch(setCommonConfig({ key: 'gameType', value: '5d6d' }));
  }, [])

  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = marketStatus.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = marketStatus.showMultipleFullbet;
    } else {
      multiple = marketStatus.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type, marketStatus]);
  
  return (
    <>
      <div className="inner_nav-tabwrapper">
        {marketStatus.fullbetStatus == 0 && marketStatus.prize123Status == 0 ? '' :
          <div
            className={`inner_tab ${activeTab === 1 ? "active" : ""}`}
            onClick={() => handleTabClick(1)}
          >
            DISCOUNT
          </div>
        }
        {marketStatus.fullbetStatus == 0 ? '' :
          <div
            className={`inner_tab ${activeTab === 2 ? "active" : ""}`}
            onClick={() => handleTabClick(2)}
          >
            FULLBET
          </div>
        }
        {marketStatus.prize123Status == 0 ? '' :
          <div
            className={`inner_tab ${activeTab === 3 ? "active" : ""}`}
            onClick={() => handleTabClick(3)}
          >
            PRIZE 1,2,3
          </div>
        }
      </div>
      {
        device === "Mobile" ? (
          <>
            {/* <VersiWAP /> */}
            {/* <Rules /> */}
            {app_type === "wap" ?
              <div className='rules_container'>
                <div>
                  <p>{props.t("guess_exact_number_3d_depan")}</p>
                  <p>Format Taruhan : ABC*EFG*HIJ#bet+LMN*OPQ#bet</p>
                  <p>Contoh Penulisan : 123*234*345#1+456*890#1+512*215#1</p>
                </div>
                <div className='rules_conversion'>
                  <p>Konversi <br /> 1 = {multipleValue}</p>
                </div>
              </div>
              : ""}
          </>
        ) : null
      }
      <div className="tabcontent-wrapper">
        {activeTab === 1 && (
          (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
            <>
              {/* {device === "Mobile" ? (
                app_type === 'wap' ? <FiveDSixDBetDiscountVersiWap /> : <Bet_Diskon />
              ) : (
                <FiveDSixDBetDiscountVersiWap />
              )} */}
              {app_type === 'wap' ? <FiveDSixDBetDiscountVersiWap /> : <Bet_Diskon />}
            </>
          )
        )}


        {activeTab === 2 && (
          (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
            <>
              {/* {device === "Mobile" ? ( */}
                {app_type === 'wap' ? <FiveDSixDBetFullVersiWap /> : <Bet_Full />}
              {/* ) : (
                <FiveDSixDBetFullVersiWap />
              )} */}
            </>
          )
        )}
        {activeTab === 3 && (
          (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
            <>
              {/* {device === "Mobile" ? ( */}
                {app_type === 'wap' ? <FiveDSixDPrizeVersiWap /> : <Prize />}
              {/* ) : (
                <FiveDSixDPrizeVersiWap />
              )} */}
            </>
          )
        )}


      </div>

    </>
  );
};

export default withTranslation()(FiveDSixDMain);
